import { useApplicationNavigation } from '@/components/modules/Application/hooks/useApplicationNavigation';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useScreen } from '@/hooks/useScreen';

export const ApplicationShowSummaryMobileButton = ({ forceShowOnDesktop }: { forceShowOnDesktop?: boolean }) => {
  const { lg, md, sm } = useScreen();
  const { toggleShowMobileSummary } = useApplicationNavigation();
  const { getTextIdTranslation } = useTranslation();
  const {
    state: { showLeftMenu },
  } = usePageContext();

  const mobileVersion = !(lg || (md && (!showLeftMenu || forceShowOnDesktop)));

  if (!mobileVersion) return null;

  return (
    <StandardButton variant="outlined" color="secondary" onClick={toggleShowMobileSummary}>
      {sm ? getTextIdTranslation('SHOW_SUMMARY') : getTextIdTranslation('SUMMARY')}
    </StandardButton>
  );
};
